import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { APP_VERSION } from "../lib/version";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    sections: [
      { h: "Éditeur du logiciel", p: "Le logiciel Fabriko est développé par Besson Solutions. Propriétaire et exploitant : La Sellerie Tout Simplement SAS, société par actions simplifiée. Directeur de la publication : le représentant légal de La Sellerie Tout Simplement SAS." },
      { h: "Coordonnées", p: "Pour toute question relative au logiciel, contactez l'éditeur via l'espace support de l'application ou par courrier au siège social de La Sellerie Tout Simplement SAS." },
      { h: "Hébergement", p: "L'application est hébergée sur une infrastructure cloud sécurisée. Les données sont stockées et traitées conformément à la réglementation applicable." },
      { h: "Propriété intellectuelle", p: "L'ensemble des éléments du logiciel (code, interfaces, marques, logos, contenus) est protégé par le droit de la propriété intellectuelle et demeure la propriété de leurs titulaires respectifs." },
    ],
  },
  cgv: {
    title: "Conditions Générales de Vente & d'Utilisation",
    sections: [
      { h: "Objet", p: "Les présentes conditions régissent l'accès et l'utilisation du logiciel Fabriko, solution de gestion pour selliers-garnisseurs (devis, factures, calcul de matière et de temps, plan d'imposition, assistant IA, boutique et réseau de sous-traitance)." },
      { h: "Abonnement & licences", p: "L'accès s'effectue par abonnement. Des modules additionnels (addons) peuvent être souscrits sous forme de licences supplémentaires. Les tarifs en vigueur sont indiqués lors de la souscription." },
      { h: "Facturation & paiement", p: "Les paiements par carte bancaire sont traités de manière sécurisée via notre prestataire de paiement. Les documents de facturation générés respectent les obligations de facturation électronique en vigueur." },
      { h: "Responsabilité", p: "Les calculs et estimations fournis par le logiciel sont donnés à titre indicatif. L'artisan reste responsable de la vérification finale de ses devis, métrages et découpes." },
      { h: "Résiliation", p: "L'abonnement peut être résilié dans les conditions prévues au contrat. Les données peuvent être exportées avant la clôture du compte." },
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    sections: [
      { h: "Données collectées", p: "Fabriko collecte les données nécessaires au fonctionnement du service : informations de compte, données de l'atelier, clients, devis, factures et calculs. Ces données appartiennent à l'atelier et sont isolées par espace (architecture multi-tenant)." },
      { h: "Finalités", p: "Les données sont utilisées uniquement pour fournir le service, générer les documents, réaliser les analyses de l'assistant IA et assurer le support." },
      { h: "Vos droits", p: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité de vos données. Vous pouvez exercer ces droits depuis votre espace ou via le support." },
      { h: "Sécurité", p: "Les mots de passe sont chiffrés, l'accès est protégé par authentification. Les données sont hébergées sur une infrastructure sécurisée." },
    ],
  },
  accessibilite: {
    title: "Déclaration d'accessibilité",
    sections: [
      { h: "Engagement", p: "Besson Solutions s'engage à rendre Fabriko accessible au plus grand nombre, conformément aux bonnes pratiques d'accessibilité numérique (WCAG 2.1 niveau AA visé)." },
      { h: "Mesures en place", p: "Contrastes de couleurs respectant les ratios recommandés, indicateurs de focus visibles, navigation clavier, libellés explicites sur les éléments interactifs et tailles de texte adaptables." },
      { h: "Amélioration continue", p: "L'accessibilité fait l'objet d'améliorations régulières. Si vous rencontrez une difficulté d'accès à une fonctionnalité, signalez-le via le support afin que nous puissions y remédier." },
    ],
  },
};

export default function Legal({ type }) {
  const navigate = useNavigate();
  const c = CONTENT[type] || CONTENT.mentions;
  return (
    <div className="max-w-3xl animate-fade-up" data-testid={`legal-${type}`}>
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-slate-500 hover:text-navy text-sm mb-4">
        <ArrowLeft className="w-4 h-4" /> Retour
      </button>
      <h1 className="text-3xl font-display font-bold text-navy">{c.title}</h1>
      <div className="mt-6 space-y-6 bg-white rounded-2xl border border-slate-200 p-6 sm:p-8">
        {c.sections.map((s, i) => (
          <section key={i}>
            <h3 className="font-display font-semibold text-navy text-lg">{s.h}</h3>
            <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{s.p}</p>
          </section>
        ))}
        <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">
          Fabriko v{APP_VERSION} — Développé par Besson Solutions · Propriétaire : La Sellerie Tout Simplement SAS. Dernière mise à jour : juin 2026.
        </p>
      </div>
    </div>
  );
}
